import { FeeBillingDueDate } from "./components";

const OP_MAP = {
  "=": null,
  "!=": "$ne",
  ">": "$gt",
  ">=": "$gte",
  "<": "$lt",
  "<=": "$lte",
};

export const amountOfUnbilledShipmentsFilter = ({ value }) => {
  const raw =
    value && typeof value === "object" ? value : { op: "=", num: value };
  const numValue = parseFloat(raw.num);
  if (isNaN(numValue)) return {};

  const apiOp = OP_MAP[raw.op];
  const apiValue = apiOp ? { [apiOp]: numValue } : numValue;
  return { amountOfUnbilledShipments: apiValue };
};

export const feeBillingDueDateFilter = ({ value }) => {
  if (value === "" || value === undefined) return {};
  if (value === null) return { feeBillingDueDate: { $exist: false } };
  return { feeBillingDueDate: value };
};

export const columns = [
  "number",
  "name",
  "billedShipmentsCount",
  "unbilledShipmentsCount",
  "amountOfUnbilledShipments",
  "feeBillingDueDate",
];

export const getColumnOptions = formatter => {
  return {
    number: {
      title: "Project Number",
      width: "14vw",
      filter: true,
    },
    name: {
      title: "Project Name",
      width: "24vw",
      filter: true,
    },
    billedShipmentsCount: {
      title: "# Shipments Billed",
      width: "4vw",
    },
    unbilledShipmentsCount: {
      title: "# Shipments Unbilled",
    },
    amountOfUnbilledShipments: {
      title: "Amount of Unbilled Shipments",
      filter: "numericComparison",
      filterOptions: {
        operator: amountOfUnbilledShipmentsFilter,
      },
      render: ({ amountOfUnbilledShipments }) => {
        return formatter.format(amountOfUnbilledShipments);
      },
    },
    feeBillingDueDate: {
      title: "Billing Due Date",
      filter: "select",
      filterOptions: {
        options: [
          { id: 5, name: "5" },
          { id: 10, name: "10" },
          { id: 15, name: "15" },
          { id: 20, name: "20" },
          { id: 25, name: "25" },
          { id: 30, name: "30" },
        ],
        operator: feeBillingDueDateFilter,
      },
      render: FeeBillingDueDate,
    },
  };
};
